"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var modal_1 = __importDefault(require("relements/build/esm/overlays/modal"));
var ShareBot_1 = __importDefault(require("@src/components/BotModals/ShareBot"));
require("./ViewCredentials.scss");
var ViewCredentials = function (_a) {
    var active = _a.active, businessId = _a.businessId, activePartner = _a.activePartner, onClose = _a.onClose;
    return (react_1["default"].createElement(modal_1["default"], { themed: true, active: active, onClose: onClose, header: react_1["default"].createElement(box_1["default"], { padding: "8px 9px" },
            react_1["default"].createElement(text_1["default"], { variant: "h2.semi-bold" }, "Test Credentials")), style: {
            padding: 0,
            overflowX: 'hidden',
        } },
        react_1["default"].createElement(ShareBot_1["default"], { businessId: businessId, partner: activePartner === null || activePartner === void 0 ? void 0 : activePartner.id })));
};
exports["default"] = ViewCredentials;
